import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "625faf95-1e9a-4735-8dde-f0cd7c9a7a63",
    content: "",
    options: {
      imageUrl: `${config.ASSETS_URL}/04/01/task/shaker.svg`,
    },
  },
  {
    id: "c099c41a-ffed-4cb5-a71f-662a239730a2",
    content: "",
    options: {
      imageUrl: `${config.ASSETS_URL}/04/01/task/geophone.svg`,
    },
  },
  {
    id: "c4779b6d-4dbe-4d71-9030-c1c97425d530",
    content: "",
    options: {
      imageUrl: `${config.ASSETS_URL}/04/01/task/tambourine.svg`,
    },
  },
  {
    id: "a8bd7011-15e0-4738-b570-2dbdc240ebdb",
    content: "",
    options: {
      imageUrl: `${config.ASSETS_URL}/04/01/task/microphone.svg`,
    },
  },
  {
    id: "de0ceecd-e721-407e-adcf-2c68f5149b2d",
    content: "",
    options: {
      imageUrl: `${config.ASSETS_URL}/04/01/task/loudspeaker.svg`,
    },
  },
  {
    id: "5eaca7e4-ee8f-48c7-8f91-e94086d668a6",
    content: "",
    options: {
      imageUrl: `${config.ASSETS_URL}/04/01/task/accelometer.svg`,
    },
  },
];

const groups = [
  {
    id: "4ee1c446-a70c-42da-838f-f4426dc7d86c",
    content: "... to electrical",
    options: {},
  },
  {
    id: "fba39cce-2524-49dc-9db8-ab79c308bfd5",
    content: "... to mechanical",
    options: {},
  },
  {
    id: "3821b002-f730-453d-bf2c-41ae379449be",
    content: "... to acoustical",
    options: {},
  },
];

export const task: Task = {
  id: "cc4e82eb-1697-4e8a-a3ae-d8a5b2cd06e8",
  solutionType: "group",
  type: "connectWithLine",
  options: {
    multipleConnection: true,
    orientation: "horizontal",
    shuffle: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    {
      groupId: "4ee1c446-a70c-42da-838f-f4426dc7d86c",
      itemsId: [
        "c099c41a-ffed-4cb5-a71f-662a239730a2",
        "a8bd7011-15e0-4738-b570-2dbdc240ebdb",
        "5eaca7e4-ee8f-48c7-8f91-e94086d668a6",
      ],
    },
    {
      groupId: "fba39cce-2524-49dc-9db8-ab79c308bfd5",
      itemsId: ["625faf95-1e9a-4735-8dde-f0cd7c9a7a63"],
    },
    {
      groupId: "3821b002-f730-453d-bf2c-41ae379449be",
      itemsId: ["c4779b6d-4dbe-4d71-9030-c1c97425d530", "de0ceecd-e721-407e-adcf-2c68f5149b2d"],
    },
  ],
};
